<template>
    <div  class="form-page">
        <my-form v-model="form" readonly table @cancle="cancleHandler">
            <my-form-item-group title="报名资料审核">
                <el-form-item label="标段名称" prop="bdname">
                    {{form.bdname||'-'}}
                </el-form-item>
                <el-form-item label="投标联系人" prop="tblxr">
                    {{form.tblxr||'-'}}
                </el-form-item>
                <el-form-item label="职务" prop="zhiwu">
                    {{form.zhiwu||'-'}}
                </el-form-item>
                <el-form-item label="手机" prop="mobile">
                    {{form.mobile||'-'}}
                </el-form-item>
                <el-form-item label="邮箱">
                    {{form.email||'-'}}
                </el-form-item>
                <el-form-item label="办公电话">
                    {{form.phone||'-'}}
                </el-form-item>
                <el-form-item label="投标人资格条件"  class="table-full-row">
                    <div v-html="zlsm"></div>
                </el-form-item> 
                <el-form-item label="上传资料" class="table-full-row">
                    <el-table :data="dataList" border>
                        <el-table-column prop="filename" label="资料名称"></el-table-column>
                        <el-table-column prop="detail" label="说明"></el-table-column>
                        <el-table-column prop="" label="是否需要验证原件">
                            <template slot-scope="scope">
                                <div v-for="(v,i) in scope.row.flist" :key="i">
                                    <my-tag type="danger" v-if="v.ordernum===1||v.ordernum===null">需要验证原件</my-tag>
                                    <my-tag type="danger" v-if="v.ordernum===2">经过CA签章，可不验证原件</my-tag>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="已上传文件名称">
                            <template slot-scope="scope">
                                <div v-for="(v,i) in scope.row.flist" :key="i">
                                    <a :href="v.downloadurl">{{v.filename}}</a>                                  
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="预览">
                            <template slot-scope="scope">
                                <div v-for="(v,i) in scope.row.flist" :key="i">
                                    <div class="demo-image__preview">
                                        <el-image  v-if="v.filetype==='jpg'"
                                            style="width: 100px; height: 100px"
                                            :src="`${getGetters('fileUrl')}/open/look.do?rowguid=`+v.rowguid" 
                                            :preview-src-list="srcList">
                                        </el-image>
                                    </div>
                                    <!-- <img :src="v.filesavepath" alt="" v-if="filetype==='jpg'" height="100px"/> -->
                                    <a :href="v.lookurl" target="_blank" v-if="v.filetype=='pdf'">
                                        <img src="./images/pdf1.png" height="100px">
                                    </a>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>
            </my-form-item-group>
        </my-form>
        <my-dialog title="审核" v-model="dialogVisible">
            <formAudit @cancle="cancleHandler" :rows="shrows" :back="back"></formAudit>
        </my-dialog>
        <div style="text-align:center;margin-top:20px;">
            <el-button type="success" v-if="form.shbj==='1'" size="small" icon="el-icon-finished"   @click="sh(form.guidcode)">审核</el-button>
        </div>               
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import DIALOG_LIST_PAGE from "@views/mixins/dialog-list-page";
import formAudit from './sub-pages/form-audit'
export default {
    mixins: [LIST_PAGE_MIXIN,DIALOG_LIST_PAGE],
    data() {
        return{
            dialogVisible:false,
            filetype:'',
            form:{},
            zlsm:'',
            zbproname:'',
            dataList:[],
            srcList:[],
            url:'',
            shrows:'',
            back:'',
        }
    },
    components:{
        formAudit
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        sh:function(guidcode){
            this.back=0
            this.shrows=guidcode;
            this.dialogVisible=true;
        },
        cancle(){

        }
    },
    created() {
        
    },
    mounted() {
        var that=this;
        if(this.$route.query.bssh!=undefined){
            if(this.$route.query.isXt==='1'){
                that.$get(`${this.getGetters('bidUrl')}/Zbdl/AuditBmZl/xingtai/detail.json`,{id:this.$route.query.id,bssh:this.$route.query.bssh}, (data, res) => {
                    that.form=JSON.parse(data.nmodel);
                    that.form.bdname=data.bdname;
                    that.dataList=data.datalist;
                    for(var i=0;i<that.dataList.length;i++){
                        for(var j=0;j<that.dataList[i].flist.length;j++){
                            that.filetype=that.dataList[i].flist[j].filetype;    
                            that.srcList.push(that.dataList[i].flist[j].lookurl)
                        }
                    } 
                    that.$post(`${this.getGetters('bidUrl')}/Tbdw/bm/getbdby2new.json`,{bdcode:that.form.bdcode},function(datas){
                        if(datas){
                            that.zlsm=datas.data;
                        }                   
                    })
                    that.zbproname=data.zbproname;
                });
            }else{
                that.$get(`${this.getGetters('bidUrl')}/Zbdl/AuditBmZl/detail.json`,{id:this.$route.query.id,bssh:this.$route.query.bssh}, (data, res) => {
                    that.form=JSON.parse(data.nmodel);
                    that.form.bdname=data.bdname;
                    that.dataList=data.datalist;
                    for(var i=0;i<that.dataList.length;i++){
                        for(var j=0;j<that.dataList[i].flist.length;j++){
                            that.filetype=that.dataList[i].flist[j].filetype;    
                            that.srcList.push(that.dataList[i].flist[j].lookurl)
                            }
                    } 
                    
                    that.$post(`${this.getGetters('bidUrl')}/Tbdw/bm/getbdby2new.json`,{bdcode:that.form.bdcode},function(datas){
                        if(datas){
                            that.zlsm=datas.data;
                        }                   
                    })
                    that.zbproname=data.zbproname;
                });   
            }
            
        }
    }
}
</script>

<style scoped lang="scss">

</style>
